const CalendarWhiteBlack = () => (
  <svg
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.3335 1.91669H12.6668V12.0834H1.3335V1.91669Z"
      stroke="#0D0D0D"
      strokeWidth="1.5"
    />
    <path d="M4.375 0V2.91667" stroke="#0D0D0D" strokeWidth="1.5" />
    <path d="M9.625 0V2.91667" stroke="#0D0D0D" strokeWidth="1.5" />
    <path
      d="M0.583496 4.95831L13.4168 4.95831"
      stroke="#0D0D0D"
      strokeWidth="1.5"
    />
  </svg>
);

export default CalendarWhiteBlack;
